/**
 * Logging Utility
 * Environment-aware logging that prevents sensitive data exposure in production
 */

const isDevelopment = process.env.NODE_ENV === 'development' || !process.env.NODE_ENV;

export const logger = {
  /**
   * Standard log - only in development
   */
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  /**
   * Warning log - only in development
   */
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  /**
   * Error log - sanitized in production
   */
  error: (...args) => {
    if (isDevelopment) {
      console.error(...args);
    } else {
      // In production, only log a generic message to prevent data exposure
      console.error('An error occurred. Enable development mode for details.');
    }
  },

  /**
   * Debug log - only in development
   */
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },

  /**
   * Info log - only in development
   */
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  }
};

// Default export
export default logger;

